import Chart from '../../components/chart/Chart'
import FeaturidInfo from '../../components/featuredInfo/FeaturidInfo'
import './home.css';
import { userData } from '../../dummyData';
import WidgetSm from '../../components/widgetSM/WidgetSm';
import WidgetLg from '../../components/widgetLG/WidgetLg';

export default function Home() {
    return (
        <div className='home'>
            <FeaturidInfo />
            <Chart data={userData} title='User Analytics' grid dataKey='Active User' />
            <div className='homeWidget'>
                <WidgetSm />
                <WidgetLg />
            </div>
        </div>
    )
}
